import { storageInUse } from 'sr/utils/localStorage'

const INTERNAL_ACCOUNTS_KEY = 'showInternalAccounts'

export const getShowInternalAccounts = (): boolean => {
  const stored = storageInUse.getItem(INTERNAL_ACCOUNTS_KEY)
  if (stored === null || stored === undefined) {
    storageInUse.setItem(INTERNAL_ACCOUNTS_KEY, 'false')
    return false
  }
  return stored === 'true'
}

export const setShowInternalAccounts = (value: boolean) => {
  storageInUse.setItem(INTERNAL_ACCOUNTS_KEY, value.toString())
}

export const getInternalAccountsKey = () => INTERNAL_ACCOUNTS_KEY
